import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { userManager } from './components/oidc-client-ts/userManager';

type AuthState = {
    returnUrl?: string;
};

const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState<string | null>(null); // Track any errors

    useEffect(() => {
        const code = searchParams.get("code");

        // If there is no `code=` in the URL, it means either:
        //   • The user navigated directly to /auth-callback (manually or via bookmark), OR
        //   • We already consumed or stripped “?code=” and someone hit “Refresh” again.
        // In either case, there’s nothing to redeem, so bail out to /login.
        if (!code) {
            // Redirect them back to login (or to home), so they don’t see “An error occurred…”
            console.warn("No code in URL, redirecting to /login");
            navigate("/login", { replace: true });
            return;
        }

        // At this point, “code” is present exactly once—on the first load after OIDC redirect.
        // Proceed to redeem it. signinRedirectCallback() will call /token internally.
        userManager.signinRedirectCallback()
            .then(user => {
                // Clear out any leftover PKCE/state, then send the user home:
                userManager.clearStaleState();

                // TODO erratic behavior when using returnUrl
                // const returnUrl = (user.state as AuthState)?.returnUrl;
                // navigate(returnUrl || "/home/following", { replace: true });
                navigate("/home/following", { replace: true });
            })
            .catch(err => {
                console.error('Login callback error:', err);
                setError('An error occurred during authentication. Please try again.');

                // Clear any remaining stale PKCE/state entries to retry login
                userManager.clearStaleState()
                    .then(() => {
                        navigate("/login", { replace: true });
                    });
            });
    }, [navigate, searchParams]);

    if (error)
        return <div>{error}</div>; // Show an error message if something went wrong

    return <div>Signing in...</div>; // Show loading state during the sign-in process
}

export default AuthCallback;